/* eslint-disable sonarjs/no-duplicate-string */
export var SOCIAL_REASON_TRANSLATIONS = {
    socialReasonInformation: {
        fields: {
            legal_information: 'Informação legal',
            confirm_registration: 'Para confirmar o registro do seu restaurante',
            restaurant: 'Restaurante',
            confirm_company_name: 'O campo serve para confirmar o nome da empresa do seu restaurante. Ele é preenchido automaticamente.',
            legal_representative: 'Representante Legal',
            socialReasonName: {
                placeHolder: 'Razão Social',
                required: 'Este campo é obrigatório',
            },
            personType: {
                placeHolder: 'Tipo de pessoa',
                required: 'El tipo de persona es requerido',
            },
            contributorType: {
                placeHolder: 'Tipo de contribuyente',
                required: 'Seleccione el tipo de contribuyente',
            },
            societaryType: {
                placeHolder: 'Tipo de Societario',
                required: 'El tipo de Societario es requerido',
            },
            commercialBusinessType: {
                placeHolder: 'Giro Comercial',
                required: 'El giro comercial es requerido',
            },
            regime: {
                placeHolder: 'Régimen tributario',
                required: 'Este campo é obrigatório',
            },
            socialReasonDocumentType: {
                placeHolder: 'Documento de identidade',
                required: 'Este campo é obrigatório',
            },
            socialReasonDocumentId: {
                placeHolder: 'Número do documento',
                required: 'El numero de documento del restuarante es requerido',
                cnpjError: 'Desculpe, ocorreu um erro ao obter as informações do seu CNPJ',
                cnaeError: 'CNAE não aceito <br> Infelizmente seu CNAE não é aceito para o cadastro no Rappi.<br>Para continuar, pedimos que realize uma alterção simples, acrescentando um CNAE válido para o ramo alimentício.',
                fiscalValidationError: 'Não foi possível realizar a validação da razão social inserida, por favor revise se os dados inseridos estão corretos.',
                socialReasonDuplicateError: 'Sentimos muito, já existe um restaurante com o ID do essa razão social. Se deseja abrir uma nova loja, por favor entre no Portal Partners > Minhas lojas, com seu email {{owner}}',
            },
            legalAgentFirstName: {
                placeHolder: 'Nome',
                required: 'Este campo é obrigatório',
            },
            legalAgentLastName: {
                placeHolder: 'Sobrenome',
                required: 'Este campo é obrigatório',
            },
            legalAgentDocumentType: {
                placeHolder: 'Documento de identidade',
                required: 'Este campo é obrigatório',
            },
            legalAgentDocumentId: {
                placeHolder: 'Número do documento',
                required: 'Este campo é obrigatório',
            },
            agentReception: {
                placeHolder: 'Mi negocio es agente de retención',
            },
            specialContributor: {
                placeHolder: 'Mi negocio es contribuyente especial',
            },
            typeContributor: 'Tipo de contribuyente',
            capitalRegime: 'Régimen capital',
            zipCode: 'Código postal',
            streetType: 'Tipo de vialidad',
            streetName: 'Nombre de vialidad',
            outsideNumber: 'Número exterior',
            interiorNumber: 'Número interior',
            location: 'Localidad',
            colony: 'Colonia',
            municipality: 'Municipio',
            federalEntity: 'Entidad federativa',
            regimeFiscal: 'Régimen fiscal',
            cfdiUse: 'Uso de CFDI',
        },
    },
};
